import React from "react";
import BasicCustomField from "../BasicCustomField";
import ApartmentsBlockIcon from "../icons/ApartmentsBlockIcon";
import HotelIcon from "../icons/HotelIcon";
import HospitalIcon from "../icons/HospitalIcon";
import CommercialCenterIcon from "../icons/CommercialCenterIcon";
import SportCenterIcon from "../icons/SportCenterIcon";
import PublicBuildingIcon from "../icons/PublicBuildingIcon";
import ElderlyHomesIcon from "../icons/ElderlyHomesIcon";
import CampingIcon from "../icons/CampingIcon";

export default class TwsInstallationType extends BasicCustomField {
    iconMaps: { [key: number]: any } = {
        0: ApartmentsBlockIcon,
        1: HotelIcon,
        2: ElderlyHomesIcon,
        3: HospitalIcon,
        4: CommercialCenterIcon,
        5: SportCenterIcon,
        6: PublicBuildingIcon,
        7: CampingIcon
    }

    renderIcon = (index: number, active: boolean) => {
        const FieldComponent = this.iconMaps[index];
        return <FieldComponent size={'giant'} active={active} />
    }

    render() {
        return <div className={`tws-installation-types`}>
            {this.props.items.map((item, index) =>
                <div onClick={() => this.onChange(item.value)} key={index} className={this.getInputClasses(index)}>
                    <div className={`tws-type-of-installation-image`}>
                        {this.renderIcon(index, this.isActiveValue(index))}
                    </div>
                    <div className={`tws-type-of-installation-label`}>
                        {item.text}
                    </div>
                </div>)}
        </div>
    }
}